import toastMessage from "../toastMessage";
import formatSelectData from "../formatSelectData";
import { getStorage } from "../storage";
import api from "../api";
import language from "../../language";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const normalizePatientHospitalizationsResponse = (
  payload,
  { type, page, limit } = {},
) => {
  const rows = Array.isArray(payload) ? payload : payload?.data || [];
  const count = Array.isArray(payload) ? payload.length : payload?.count || 0;

  if (type === "dropdown") {
    return formatSelectData(rows || [], "roomNumber", "_id").map((el) => ({
      ...el,
      label: `${el?.service?.name || "-"} | Room: ${el.roomNumber || "-"} | Bed: ${
        el.bedNumber || "-"
      }`,
      value: el?._id || el?.value,
    }));
  }

  return !page && !limit ? rows : { data: rows, count };
};

export const fetchPatientHospitalizations = async (
  lng = "english",
  { page, limit, type, id, patient, hospital, isActive, q },
) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/patient-hospitalization`,
      params: {
        page,
        limit,
        id,
        patient,
        hospital,
        isActive,
        q,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);
    return normalizePatientHospitalizationsResponse(queryRes.data, {
      type,
      page,
      limit,
    });
  } catch (error) {
    toastMessage("error", error);
  }
};

export const savePatientHospitalization = async (
  lng = "english",
  payload = {},
) => {
  try {
    const user = await getStorage();
    const method = payload?.id ? "PUT" : "POST";
    const options = {
      method,
      url: `${API_URL}/patient-hospitalization`,
      data: payload,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const res = await api(options);
    toastMessage(
      "success",
      language[lng][method === "PUT" ? "update_data_success" : "add_data_success"],
    );
    return res?.data;
  } catch (error) {
    toastMessage("error", error);
    throw error;
  }
};

export const deletePatientHospitalization = async (lng = "english", id) => {
  try {
    const user = await getStorage();
    const options = {
      method: "DELETE",
      url: `${API_URL}/patient-hospitalization`,
      data: { id },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };
    await api(options);
    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
    throw error;
  }
};
